import { Link } from "react-router-dom";
import { Bookmark } from "lucide-react";
import { timeAgo } from "@/lib/api";

export default function NewsCard({ article, compact = false }) {
  if (!article) return null;
  return (
    <Link
      to={`/nota/${article.slug}`}
      className="card-hover group block"
      data-testid={`news-card-${article.slug}`}
    >
      <div className="overflow-hidden rounded-sm aspect-[4/3] mb-2 md:mb-3" style={{ background: "var(--surface-2)" }}>
        {article.featured_image && (
          <img
            src={article.featured_image}
            alt={article.title}
            className="card-img w-full h-full object-cover"
            loading="lazy"
          />
        )}
      </div>
      <div className="flex items-center gap-2 mb-1.5 md:mb-2 overline">
        <span className="accent-text">{article.category_slug?.toUpperCase()}</span>
        <span style={{ color: "var(--text-muted)" }}>·</span>
        <span style={{ color: "var(--text-muted)" }}>{timeAgo(article.published_at)}</span>
      </div>
      <div className="flex items-start justify-between gap-2 md:gap-3">
        <h3
          className={`font-headline uppercase ${compact ? "text-sm md:text-base" : "text-sm md:text-lg lg:text-xl"} leading-tight tracking-tight group-hover:opacity-80 transition`}
          style={{ color: "var(--text)" }}
        >
          {article.title}
        </h3>
        <button
          onClick={(e) => { e.preventDefault(); }}
          className="shrink-0 mt-1 hover:accent-text transition"
          aria-label="Guardar"
          data-testid={`bookmark-${article.slug}`}
        >
          <Bookmark size={18} />
        </button>
      </div>
    </Link>
  );
}
